searchToggle = document.querySelector('#search-type-toggle');

const addButtonStyle = function() {
  const searchButtons = document.querySelectorAll('.search-type-button');
  for (searchButton of searchButtons) {
    if (searchButton.dataset.type === searchToggle.value) {
      searchButton.classList.add('active');
    }
  }
}

document.querySelector('.search-type-wrapper').addEventListener('click', function(e) {
  const target = e.target;
  const searchType = target.dataset.type;
  if (!target.classList.contains('search-type-button')) return;
  searchToggle.value = searchType;
  localStorage.setItem('searchType', searchToggle.value);
  document.querySelector('#search-page-form').submit();
});

window.addEventListener('load', function() {
  searchToggle.value = localStorage.getItem('searchType');
  addButtonStyle();
});


